import styled from 'styled-components';
import { InnerTooltipProps } from './Tooltip.consts';

export const StyledInnerTooltip = styled.span<InnerTooltipProps>`
  ${(props) => props.$padding && `padding: ${props.$padding};`};
  align-items: center;
  display: flex;
  height: 100%;
`;
